//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BottomNav from "../components/BottomNav";

export default {
    name: "serve",
    components: {
        BottomNav,
    },
    data() {
        return {
            serveIcons: [
                {
                    image: require('@/assets/img/serve-ico1.png'),
                    title: '小区广播',
                    name: '/broadcast',
                },
                {
                    image: require('@/assets/img/serve-ico2.png'),
                    title: '工程报修',
                    name: '/repair',
                },
                {
                    image: require('@/assets/img/serve-ico3.png'),
                    title: '投诉咨询',
                    name: '/suggest',
                },
                {
                    image: require('@/assets/img/serve-ico4.png'),
                    title: '照片墙',
                    name: '/photos',
                },
                {
                    image: require('@/assets/img/serve-ico5.png'),
                    title: '悦福利',
                    name: '/coupon',
                },
            ],
            assistant: [
                /*{
                    image: require('@/assets/img/pic-kp.png'),
                    title: '科普知识',
                    name: '/science',
                },*/
                {
                    image: require('@/assets/img/pic-fw.png'),
                    title: '生活服务',
                    name: '/lifeHelp',
                },/*
                {
                    image: require('@/assets/img/pic-tip.png'),
                    title: '还款提醒',
                    name: '/broadcast',
                },*/
                {
                    image: require('@/assets/img/pic-serv.png'),
                    title: '便民服务',
                    name: '/serveMsg',
                }
            ],
            isShowCert: false,
            member: {},
            scienceList: [],
        };
    },
    methods: {
        getContentByNodeName() {
            abp.ajax.get('/api/services/app/Node/GetNodesByName?=' + '科普知识').then((res) => {
                var scienceList = res.data.result.items[0].children;
                // console.log(scienceList);
                this.scienceList.push(...res.data.result.items[0].children);
                /*if (scienceList.length > 0) {

                    /!*this.getGraphicInformationByBusiness(list[0].id)*!/

                }*/
            });
        },
        async getMyMember() {
            var vm = this;
            await this.$store.dispatch({
                type: 'member/getMyMember'
            }).then(() => {
                vm.member = {};
                vm.member = vm.$store.state.member.memberInfo;
                localStorage.setItem('MemberId', vm.member.id);
                localStorage.setItem('MemberLevel', vm.member.memberLevel);
            });
        },
        onGridClicked(name) {
            if (JSON.stringify(this.member) === '{}') {
                return;
            }
            if (name === '/welfare' || name === '/deliverOrder' || name === '/repair' || name === '/suggest' || name === '/houseCard') {
                if (this.member.isAuthentication) {
                    // console.log(this.isShowCert);
                    this.$router.push(name);
                } else {
                    this.isShowCert = true;
                    return;
                }
            } else {
                this.$router.push(name);
            }
        },
        certificate() {
            this.$router.push({path: '/character'})
        },
    },
    created() {
        this.getMyMember();
        this.getContentByNodeName();
    }
}
